/** @module CollectionBook/StyleSelectMarketingCollections */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/action/FormData",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query"
], function(declare,Controller,FormData,ActionControllerMixin,xml,Query) {

	var SELECT_MARKETING_COLLECTIONS_PAGE = 0;
	var SELECT_COLORWAYS_PAGE = 1;

	return declare([Controller,ActionControllerMixin], {
		_fdCollections: null,
		_fdColorways: null,

		getWizardViewQuery: function(wizard, view, index) {
			// C8-5558: Filter out Inactive colorways
			if (index == SELECT_COLORWAYS_PAGE) {
				return new Query().Attr("Active", xml.OP_EQUALS, true);
			}

			return null;
		},

		onNextPage: function(wizard,currentPage,nextPage,bFinish) {
			// C8-5379 : Update Style's "Select Marketing Collections" form to allow users to selectively add colorways to Marketing Collections
			var	nPage = wizard.getIndexOfPage(nextPage);
			var	dfd, fd;
			var	bRefresh = false;

			switch (nPage) {
				case SELECT_MARKETING_COLLECTIONS_PAGE:
					// select marketing collections
					fd = this._fdCollections = this.m_formData;
					fd.m_bRequireOne = true;
					break;

				case SELECT_COLORWAYS_PAGE:
					// select colorways page: use user selected colorways disregard MarketingCollection's 'auto add colorways' flag
					fd = this._fdColorways = this._fdColorways || new FormData(this);

					// Pre-select all colorways if first collection's AddColorwaysAutomatically is true
					var collections = this._fdCollections.getSelectedNodes();
					fd.bPreselectAll = collections[0].AddColorwaysAutomatically;
					break;
			}

			if (fd) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		},

		toWriterRequest: function() {
			// summary: add Colorways parameter
			var	call = this.inherited(arguments);
			if (this._fdColorways) {
				call.addParameter("ColorwayURLs", xml.ATTR_REFLIST, this._fdColorways.getSelectedValue());
			}
			return call;
		}

	});
});